import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, Check, ArrowRight } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const BULLETS = [
  'Three passes: multi-perspective outline → per-subsection draft → claim verification',
  '2× evidence chunks with hybrid retrieval + LLM-as-judge reranking',
  'Per-section expert prompts tuned for Methods, Results, Discussion and more',
  'Numbered Vancouver citations re-verified against your own library',
];

export const PremiumUpgradeDialog = ({ open, onOpenChange, premium }) => {
  const exhausted = (premium?.limit ?? 0) > 0;
  const minPlan = premium?.min_plan || 'Researcher';
  const planName = premium?.plan_name || 'current';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="premium-upgrade-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-amber-700">
            <Crown className="w-5 h-5" /> InkPhD Deep Writer
          </DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground" data-testid="premium-upgrade-reason">
          {exhausted
            ? `You have used all ${premium.limit} Deep Writer sections included in your ${planName} plan this month (${premium.used} used). Upgrade to Doctoral for unlimited runs.`
            : `The InkPhD Deep Writer is included from the ${minPlan} plan onwards. Your ${planName} plan does not include it yet.`}
        </p>

        <ul className="space-y-2 text-sm">
          {BULLETS.map((b) => (
            <li key={b} className="flex items-start gap-2">
              <Check className="w-4 h-4 mt-0.5 shrink-0 text-amber-600" />
              <span>{b}</span>
            </li>
          ))}
        </ul>

        <div className="rounded-lg border border-amber-300/60 bg-amber-50 dark:bg-amber-500/10 p-3 text-[13px]"
          data-testid="premium-upgrade-weight-note">
          <span className="font-semibold">Why it costs more: </span>
          {premium?.weight_note
            || 'Each premium run executes a three-pass pipeline (4-8 model calls) with double the evidence, so it counts as 5 generations against your monthly allowance.'}
        </div>

        <p className="text-[11px] text-muted-foreground" data-testid="premium-upgrade-method-note">
          Method note: multi-perspective outline after STORM (Stanford) and self-verification
          after OpenScholar (AI2), implemented on InkPhD&apos;s own hybrid retrieval.
        </p>

        <div className="flex items-center justify-between gap-3 pt-1">
          <span className="text-xs text-muted-foreground">
            Researcher €39 — 5 / month · Doctoral €89 — unlimited
          </span>
          <Link to="/thesis/billing" data-testid="premium-upgrade-cta">
            <Button className="bg-amber-700 hover:bg-amber-800 text-white">
              See plans <ArrowRight className="w-4 h-4 ml-1.5" />
            </Button>
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PremiumUpgradeDialog;
